module.exports = __webpack_public_path__ + "img/nonView.4422bc29.svg";